import React, { useRef, useState } from "react";
import addpoststyle from "./addpost.module.css";
import { HiOutlinePhoto } from "react-icons/hi2";
import { GoVideo } from "react-icons/go";
import { FaRegPaperPlane } from "react-icons/fa";
import { RxImage } from "react-icons/rx";
import { FaUserFriends } from "react-icons/fa";
import defaultImage from "../../appImges/avatartTemplate/default_img.png";
import axios from "axios";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_URL;

const AddPost = ({ username, userImage, onNewPost }) => {
  /**
   * This component is responsible for adding a new post. The post can contain text, and in addition - an image or an embedded video.
   * Props:
   * username - The username of the user who is adding the post
   * userImage - The profile image of the user who is adding the post
   * onNewPost - a method to call after adding the post to the database
   */

  const [showVideoInput, setShowVideoInput] = useState(false);
  const [content, setContent] = useState("");
  const [videoLink, setVideoLink] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const [isPalsOnly, setIsPalsOnly] = useState(false);

  /**
   * Handle checking / unchecking the Pals Only checkbox for the new post.
   */
  const handleIsPalsOnlyChange = (event) => {
    setIsPalsOnly(event.target.checked);
  };

  /**
   * Handle image file upload
   */
  const handleFileInputChange = () => {
    const file = fileInputRef.current.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  /**
   *
   */
  const handleIconClick = () => {
    fileInputRef.current.click(); // Trigger the file input click
  };

  /**
   * Submit a post to the database.
   */
  const handlePostSubmit = async () => {
    if (content === "" && selectedFile === null && videoLink === null) {
      return;
    }

    const formData = new FormData();
    formData.append("username", username);
    formData.append("content", content);

    if (videoLink) {
      formData.append("video_link", videoLink);
    }

    formData.append("img_link", selectedFile);

    formData.append("viewing_permission", isPalsOnly ? 0 : 1);
    formData.append("comment_permission", true);

    try {
      const response = await axios.post(`${apiUrl}/posts/create`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });

      if (response.status === 200 && response.data.success) {
        toast.success("Post added successfully");

        if (onNewPost) {
          onNewPost(response.data.post);
        }

        // Clear the form
        setContent("");
        setVideoLink(null);
        setSelectedFile(null);
        setShowVideoInput(false);
      } else {
        console.error("Failed to add post:", response.statusText);
      }
    } catch (error) {
      console.error("Error adding post:", error);
    }
  };

  return (
    // main section
    <div>
      <div className={addpoststyle.mainaddpost}>
        {/* left div with photo and name */}
        <div className={addpoststyle.rightDiv}>
          <figure className={addpoststyle.imagestyle}>
            <img
              src={
                userImage && userImage !== "default_img_link"
                  ? userImage
                  : defaultImage
              }
              alt={username}
              onError={(e) => {
                e.target.src = defaultImage;
                e.target.onerror = null; // Prevents infinite loop if the default image is also not found
              }}
            />
            <figcaption>{username}</figcaption>
          </figure>
        </div>
        {/* right div with textarea and buttons */}
        <div className={addpoststyle.leftDiv}>
          <div className={addpoststyle.textareaContainer}>
            <textarea
              className={addpoststyle.textarea}
              placeholder={`What's on your mind, ${username}?`}
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
            {selectedFile && <RxImage className={addpoststyle.uploadedIcon} />}
          </div>
          {showVideoInput && (
            <input
              type="text"
              placeholder="Add a video link"
              value={videoLink}
              onChange={(e) => setVideoLink(e.target.value)}
              className={addpoststyle.inputVideoLink}
            />
          )}
          <div className={addpoststyle.buttonDiv}>
            <div className={addpoststyle.leftButtons}>
              <input
                type="file"
                accept=".jpg, .png, .jpeg, .gif"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileInputChange}
              />
              <button className={addpoststyle.button} onClick={handleIconClick}>
                <HiOutlinePhoto />
              </button>
              <button
                className={addpoststyle.button}
                onClick={() => setShowVideoInput(!showVideoInput)}
              >
                <GoVideo />
              </button>
            </div>
            <div className={addpoststyle.rightButtons}>
              <div className={addpoststyle.isPalsOnly}>
                <label>
                  <input
                    type="checkbox"
                    checked={isPalsOnly}
                    onChange={handleIsPalsOnlyChange}
                  />
                  <FaUserFriends />
                  <span className={addpoststyle.palsOnlyText}>Pals Only</span>
                </label>
              </div>
              <button
                className={addpoststyle.button3}
                onClick={handlePostSubmit}
              >
                <FaRegPaperPlane />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPost;
